export default "__VITE_ASSET__D$RXWHZ___"